import React from 'react';
import { useLanguage } from '../../context/language-context-provider';
const HumanStatistics = () => {
  const {
    t
  } = useLanguage();
  return <div className='flex flex-col items-center justify-center gap-6 py-5.5 lg:flex-row lg:py-6' data-sentry-component="HumanStatistics" data-sentry-source-file="human.tsx">
            <div className='item'>
                <span className='title'>{t('statistics.human.item1.title')}</span>
                <span className='value'>{t('statistics.human.item1.text')}</span>
            </div>
            <div className='item'>
                <span className='title'>{t('statistics.human.item2.title')}</span>
                <span className='value'>{t('statistics.human.item2.text')}</span>
            </div>
        </div>;
};
export default HumanStatistics;